import AjaxCommons from '@/services/ajax-commons';

export interface AuthResponse {
  result: string;
  session: string;
}
class AuthApiAgentImpl {

  public isAdmin: boolean;

  constructor(private ajax = AjaxCommons) {}

  public auth: (username: string, password: string) => Promise<AuthResponse> = (username: string, password: string) => {
    return this.ajax.post('type=auth', {
      username,
      password,
    });
  }

  public check() {
    return this.ajax.get('type=check');
  }

}

const AuthApiAgent = new AuthApiAgentImpl();

export default AuthApiAgent;
export { AuthApiAgentImpl };
